<template>
    <div id="pm-smart-animation-view" :class="isiOS ? 'pm-smart-animation-view--ios' : 'pm-smart-animation-view--android'">
        <div :class="$theme.contentBg">
            <div v-if="!error" style="margin: 0; padding: 8px 16px;">
                <div style="display: flex; align-items: center;">
                    <div style="flex-grow: 1" class="animation--category-title-wrapper">
                        <span v-for="category in item.categories" :key="category" class="roboto f11 grey--text animation--category-title">
                            <!--{{ $t(`animation_items.category_${category}`) }}-->
                            {{ category }}
                        </span>

                        <br/>
                        <div style="flex-grow: 1; max-width: Calc(100vw - 160px); overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" :class="$theme.defaultText" class="bold--text roboto f14 animation--category-subtitle" v-html="getTitle" />
                    </div>
                    <div style=" display: flex; justify-content: center; align-items: center;" class="animation--view-buttons">
                        <!--mdi v-show="ccAvailable" style="margin-right: 8px;" @click.native="toggleCaptions">closed-caption-outline</mdi-->

                        <span v-if="item.subtitles" @click="toggleCaptions" style="color: #000; display: inline-block; font-size: 9px; text-align: center; line-height: 1; margin-right: 12px;">
                            {{$t('core.subtitles')}}<br/>
                            <span v-show="ccEnabled" style="width: 36px; text-align: center; margin-top: 2px; background: rgb(243, 187, 1); display: inline-block; border-radius: 4px; padding: 2px 0; color: #000; font-weight: 600;font-size: 12px;">{{ $t('core.state_on') }}</span>
                            <span v-show="!ccEnabled" style="width: 36px; text-align: center; margin-top: 2px; background: #ccc; display: inline-block; border-radius: 4px; padding: 2px 0; color: #fff; font-weight: 600;font-size: 12px;">{{ $t('core.state_off') }}</span>
                        </span>

                        <mdi v-show="bookmarked" @click.native="toggleBookmark">heart</mdi>
                        <mdi v-show="!bookmarked" @click.native="toggleBookmark">heart-outline</mdi>

                        <span @click="closeVideo" style="display: inline-block; padding: 10px; margin: -7px -10px -7px 12px;">
                            <v-icon style="background: #eee; padding: 5px; border-radius: 50%;" @click="closeVideo">close</v-icon>
                        </span>
                    </div>

                    <!--v-chip small
                            label
                            text-color="white"
                            class="f10"
                            style="height: 14px!important;"
                    >
                        {{ item.duration }}
                    </v-chip-->
                    <!--div v-if="inited && !isFullscreen" class="video-close-btn" style="xposition: absolute; top: 8px; " @click="closeVideo">
                            <v-icon style="font-size: 17px; margin: -1px 0 0 0; padding: 0;">
                                close
                            </v-icon>
                        </div-->
                </div>
                <!--div style="display: flex">
                    <div style="flex-grow: 1" :class="$theme.defaultText" class="bold--text roboto f14" v-html="getTitle" />
                </div-->
            </div>
            <div style="clear: both; overflow: hidden;">
                <div :class="$theme.contentBg" style="padding-top: 56.25%; position: relative; border-radius: 0px; overflow: hidden;">
                    <div :class="$theme.contentBg" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;">
                        <div v-if="error" class="video-js" style="height: 100%; background: #999999; display: flex; align-content: center; justify-content: center;align-items: center; justify-items: center">
                            <div style="text-align: center;">
                                {{ $t('animation_view.error') }}
                            </div>
                        </div>
                        <div id="video-player-inner" :class="[ isFullscreen ? 'pm-video-android-fullscreen' : '' ]" v-else-if="inited">

                            <video
                                :key="ccEnabled"
                                :webkitPlaysinline=playsinline
                                :playsinline=playsinline
                                ref="videoElement"
                                controls

                                :autoplay=autoplay
                                muted
                                disablePictureInPicture
                                controlsList="nodownload"
                                :class="[ isFullscreen ? 'x-pm-video-android-fullscreen' : 'pm-video' ]"
                                :poster="poster"
                                v-on:touchstart="() => { showFullscreenButton(); hideFullscreenButton(3000); }"
                                style="min-height: 205px"
                            >
                                <source v-if="supportsHLS && ccEnabled" :src="videoSource + '.m3u8'" type="application/x-mpegURL">
                                <source v-if="supportsHLS && !ccEnabled" :src="videoSource + '.m3u8'" type="application/x-mpegURL">
                                <source v-if="ccEnabled" :src="videoSource + '_x264.mp4'" type="video/mp4">
                                <source v-if="!ccEnabled" :src="videoSource + '_x264.mp4'" type="video/mp4">
                            </video>

                        </div>

                        <div v-else class="video-js" style="height: 100%; background: #999999; display: flex; align-content: center; justify-content: center;align-items: center; justify-items: center">
                            <div style="text-align: center;">
                                {{ $t('animation_view.loading') }}
                            </div>
                        </div>

                        <div v-if="isFullscreen" class="video-close-btn" style="position: fixed; bottom: 8px; " @click="closeVideo">
                            <v-icon style="font-size: 17px; margin: -1px 0 0 0; padding: 0;">
                                close
                            </v-icon>
                        </div>

                        <div v-show="fullScreenButtonVisible" v-if="inited && !isFullscreen" class="video-fullscreen-btn" @click="isFullscreen = !isFullscreen"></div>

                        <div v-show="fullScreenButtonVisible" v-if="isFullscreen" class="video-fullscreen-btn" :class="[ isFullscreen ? 'fullscreen' : '']" @click="isFullscreen = !isFullscreen"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.\!prevent-rotate {
    transform: rotate(0) !important;
    width: 100vw !important;
    max-width: initial !important;
}

    #video-player-inner {
        background: #000;
    }
    #pm-smart-animation-view video {
        object-fit: contain;
        max-height: Calc(100vh - 196px);
    }
    .video-close-btn {
        transition: opacity 1s; z-index: 2147483647; right: 8px; width: 32px; height: 32px; line-height: 32px; text-align: center; background: rgba(255,255,255,.75); border-radius: 50%;
    }

    .pm-smart-animation-view--ios .video-close-btn {
        top: 10px!important;
        background: #242424;
        width: 60px!important;
        border-radius: 12px!important;
    }
    .pm-smart-animation-view--ios .video-close-btn .v-icon {
        color: #fff!important;
    }

    video::-webkit-media-controls-mute-button {
        opacity: 0!important;
        display: none!important;
        -webkit-appearance:none;
    }

    video::-webkit-media-controls-seek-back-button, video::-webkit-media-controls-seek-forward-button, video::-webkit-media-controls-return-to-realtime-button, video::-webkit-media-controls-toggle-closed-captions-button {
        display: none!important;
        -webkit-appearance:none;
    }

   .pm-video-android-fullscreen {
        width: 100vw !important;
        max-height: 100vh;
        position: fixed;
       top: 0;
       left: 0;
       right: 0;
       bottom: 0;
        /*top: 21.9vh;
        left: -21.9vh;*/
        z-index: 4;
       background: #000;
       display: flex;
       align-items: center;
       justify-content: center;

        /*transform: rotate(90deg);
       transform-origin: center center;*/
    }

   .pm-video-android-fullscreen video {
       transform: rotate(90deg);
       transform-origin: center center;
       max-width: 100vh;
       max-height: 100vw !important;
   }

    .pm-video {
        width: 100vw;
    }

    #pm-smart-animation-view video::-webkit-media-controls-mute-button {
        display:none;
    }
    #pm-smart-animation-view video::-webkit-media-controls-volume-slider {
        display:none;
    }
    #pm-smart-animation-view video::-webkit-media-controls-volume-container {
        display:none;
    }

    .video-fullscreen-btn {
        /* border: 1px solid #f00;*/
        transition: opacity 1s;
        position: absolute;
        z-index: 5;
        right: 12px;
        bottom: 36px;
        width: 44px;
        height: 34px;
        line-height: 32px;
        text-align: center;
    }

    .video-fullscreen-btn.fullscreen {
        position: fixed;
        left: 10px;
        bottom: 61px;
        transform: rotate(90deg);
        width: 84px;
    }

    .vjs-user-inactive + .video-close-btn {
        opacity: 0;
    }
    .vjs-paused + .video-close-btn,
    .vjs-ended + .video-close-btn {
        opacity: 1;
    }
    #pm-smart-animation-view {
        overflow: auto;
    }
    .vjs-picture-in-picture-control {
        display: none !important;
    }
    #pm-smart-animation-view .v-chip {
        height: 12px;
        font-size: 10px;
        background: #7B8088;
        border-radius: 4px;
    }
    #pm-smart-animation-view .v-chip .v-chip__content {
        padding: 0 3px 0 3px;
    }

@media (orientation: landscape) and (min-width: 700px) {
    .video-fullscreen-btn {
        display: none !important;
    }

    .video-close-btn {
        top: 8px !important;
        bottom: unset !important;
    }
}

@media (orientation: portrait) and (min-width: 700px) {
    .video-close-btn {
        top: 8px !important;
        bottom: unset !important;
    }
}

@media (min-width: 700px) {
    .animation--category-title-wrapper {
        padding-top: 6px;
    }

    .animation--category-title {
        font-size: 14px;
    }

    .animation--category-subtitle {
        font-size: 18px;
    }

    .animation--view-buttons {
        padding-top: 8px !important;
    }

    .animation--view-buttons svg {
        transform: rotate(0deg) scale(1.5) !important;
    }

    .animation--view-buttons .v-icon {
        margin-left: 26px !important;
        margin-right: 8px;
        font-size: 24px !important;
    }
}
</style>

<script>
import { supportsHLS } from "../../utils/device/media-support";
// import AdManager from "@/extensions/managers/ad-manager";
import { commands, semaphore } from "@/utils/flutter/flutter2-semaphore";
import { invokeFlutterService } from '@/utils/flutter/flutter-service';
export default {
    props: {
        id: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        inited: false,
        error: false,
        showDescription: false,
        player: null,
        isFullscreen: false,
        fullScreenButtonVisible: true,

        prevVideoTime: 0,
        totalVideoTime: 0,
        adShowed: false,
        bookmarked: false,
        ccAvailable: false,
        ccEnabled: false,
        forcedResumeTime: 0,
        videoSource: '',
        isRotationAvailable: (localStorage.getItem('flutterVersion') || '').localeCompare('3.8.16') >= 0,
    }),
    computed: {
        playsinline() {
            return !localStorage.getItem('adv-settings-video-disable-playsinline');
        },
        autoplay() {
            return !localStorage.getItem('adv-settings-video-disable-autoplay');
        },

        supportsHLS() {
            return supportsHLS();
        },
        item() {
            const item = this.getItem();
            item.video = item.video.replace("https:", "");
            this.ccAvailable = item.subtitles !== false;
            // this.ccAvailable = true; // @TODO: remove after test
            this.ccEnabled = localStorage.getItem('ccEnabled') === 'true';
            return item;
        },
        poster() {
            /** @type {import('@/types').AnimationProps} */
            const props = this.$store.state.animation.props;

            return `https://cdn.denticalc.com/videos/${encodeURIComponent(this.item.video)}${props.poster_postfix}`;
        },
        isiOS() {
            return !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
        },
        getTitle() {
            const language = this.$store.state.language || 'en';
            let title = this.item.title[language] || this.item.title['en'];

            if (typeof this.item.subtitle === 'undefined' ) return title;
            if (typeof this.item.subtitle.en === 'undefined') return title;

            title += ' ' + (this.item.subtitle[language] || '');

            return title.trim();
        },
    },
    beforeDestroy() {
        this.removeVideoEventListeners();
        this.incrementViewCounter();

        window.Tracker.logEvent({
            event_name: "video_close",
            event_category: "video",
            event_label: String(this.item.title.en),
            event_value: this.totalVideoTime,
        });

        window.Tracker.logEvent({
            event_name: 'video_views',
            event_category: "video",
            event_label: 'videoViews',
            event_value: parseInt(localStorage.getItem('videoViews') || '0', 10),
        });

        invokeFlutterService("FlutterWakelockService", "unlock");

        if ('SemaphoreJavascriptChannel' in window) {
            semaphore({
                name: commands.wakelock.command,
                data: {
                    value: commands.wakelock.disableWakelock,
                },
            })
        }
    },
    created() {
        window.addEventListener('orientationchange', () => {
            if (!this.isRotationAvailable) return;

            const video = document.querySelector('.pm-video-android-fullscreen video');

            video && video.classList.add('!prevent-rotate');
        });
    },
    mounted() {
        this.videoSource = this.getVideoSource();
        this.bookmarked = this.getBookmarked();

        invokeFlutterService("FlutterWakelockService", "lock");

        if ('SemaphoreJavascriptChannel' in window) {
            semaphore({
                name: commands.wakelock.command,
                data: {
                    value: commands.wakelock.enableWakelock,
                },
            })
        }

        // screen.orientation.unlock();
        setTimeout(() => {
            this.inited = true;
            this.$nextTick(() => {
                this.bindVideoEventListeners();
                window.Tracker.logEvent({
                    event_name: "play_video",
                    event_category: "video",
                    event_label: this.item.title.en,
                });
                // if (AdManager.show('animations')) {
                //     this.$refs.videoElement.pause();
                // }
            });
        }, 500);

        if (!this.$IAP.hasAccessToComponent('videos')) {
            setTimeout(() => {
                this.closeVideo();
                // this.$bus.$emit("free_trial:show", {
                //     countdown: 0,
                //     route: '/animations',
                // });
                this.$bus.$emit('openAppDialog','premium', { 'referrer': 'auto_video_5s' });
            }, 5000);
        }
    },
    methods: {
        forceUpdateVideo() {
            this.forceupdated = true;
            const el = this.$refs.videoElement;
            if(el) {
                this.forcedResumeTime = this.$refs['videoElement'].currentTime;
                this.removeVideoEventListeners();
                el.pause();
            }
            this.videoSource = "";
            this.$nextTick(()=>{
                this.videoSource = this.getVideoSource();
                this.$nextTick(()=>{
                    this.bindVideoEventListeners();
                    el.play();
                });
            });
        },
        getVideoSource() {
            const src = `https://cdn.denticalc.com/videos/${this.item.video}_nosub_480p_sq`;

            if (localStorage.getItem('ccEnabled') === 'true' || this.item.subtitles === false) {
                return src.replace('_nosub', '');
            }

            return this.ccEnabled ? src.replace('_nosub', '') : src;
        },
        toggleCaptions() {
            const el = this.$refs.videoElement;
            if(el) {
                this.forcedResumeTime = this.$refs['videoElement'].currentTime;
                this.removeVideoEventListeners();
                el.pause();
            }
            this.ccEnabled = !this.ccEnabled;
            localStorage.setItem('ccEnabled',this.ccEnabled);
            this.videoSource = this.getVideoSource();
            this.$nextTick(()=>{
                this.bindVideoEventListeners();
            })
        },
        getBookmarked() {
            try {
                // @todo: add cache
                const favvedItems = localStorage.getItem('videoBookmarks');
                // TODO: null || '[]'
                if (favvedItems === null) return false;
                const items = JSON.parse(favvedItems);

                return Array.isArray(items) ? items.includes(this.id) : false;
            } catch(error) {
                captureException(error);
                return false;
            }
        },
        toggleBookmark() {
            const favvedItems = localStorage.getItem('videoBookmarks');
            const items = (favvedItems === null) ? [] : JSON.parse(favvedItems);
            const idx = items.indexOf(this.id);
            if (idx < 0) items.push(this.id);
            else items.splice(idx, 1);
            localStorage.setItem('videoBookmarks', JSON.stringify(items));
            this.bookmarked = !this.bookmarked;
        },
        incrementViewCounter() {
            try {
                if (!this.$refs.videoElement) return;
                let viewCounter = {};
                if (localStorage.getItem('videoViewCounter') !== null) {
                    viewCounter = JSON.parse(localStorage.getItem('videoViewCounter'));
                }
                if (typeof viewCounter[String(this.id)] === 'undefined') viewCounter[String(this.id)] = { played: 0, percent: 0, avg: 0 };
                viewCounter[String(this.id)].played++;
                const precision = 3;
                const percent = Math.round((viewCounter[String(this.id)].percent + (this.totalVideoTime / this.$refs.videoElement.duration)) * Math.pow(10, precision)) / Math.pow(10, precision);
                const avg = Math.round((viewCounter[String(this.id)].percent / viewCounter[String(this.id)].played) * Math.pow(10, precision)) / Math.pow(10, precision);
                viewCounter[String(this.id)].percent = percent;
                viewCounter[String(this.id)].avg = avg;
                localStorage.setItem('videoViewCounter', JSON.stringify(viewCounter));

                let videoTime = parseFloat(localStorage.getItem('videoTime')) || 0;
                videoTime += this.totalVideoTime;
                localStorage.setItem('videoTime', videoTime);

                let videoViews = localStorage.getItem('videoViews') || 0;
                videoViews++;
                localStorage.setItem('videoViews', videoViews);
            } catch(error) {
                captureException(error);
            }
        },
        closeVideo() {
            // alert('close');
            // this.removeVideoEventListeners();
            this.$emit('close');
        },
        bindVideoEventListeners() {
            const el = this.$refs.videoElement;
            if(!el) return;

            el.addEventListener('click', this.showFullscreenButton);
            el.addEventListener('ended', this.showFullscreenButton);
            el.addEventListener('pause', this.showFullscreenButton);
            el.addEventListener('play', this.hideFullscreenButton);
            el.addEventListener('seeked', this.hideFullscreenButton); //@todo: paused + seeked
            el.addEventListener('timeupdate', () => {
                // this.resumeVideo();
                this.updateVideoTimeTracker();
            });
            el.addEventListener('loadeddata', this.resumeVideo);
            // el.addEventListener('loadedmetadata', this.onVideoMetaLoaded);
        },

        resumeVideo() {
            if (!this.forceupdated && localStorage.getItem('adv-settings-video-force-update')) this.forceUpdateVideo();
            if (!this.playsinline) {
                try {
                    this.$refs.videoElement.webkitEnterFullscreen();
                } catch (e) {
                    console.error(e);
                }
            }
            if (this.forcedResumeTime === 0 || isNaN(parseFloat(this.forcedResumeTime))) return;
            const el = this.$refs.videoElement;
            if(!el) return;

            if(el.currentTime < 1) el.currentTime = this.forcedResumeTime;
            // if (el.currentTime === this.forcedResumeTime) this.forcedResumeTime = 0;
        },

        removeVideoEventListeners() {
            const el = this.$refs.videoElement;
            if(!el) return;

            el.removeEventListener('click', this.showFullscreenButton);
            el.removeEventListener('ended', this.showFullscreenButton);
            el.removeEventListener('pause', this.showFullscreenButton);
            el.removeEventListener('play', this.hideFullscreenButton);
            el.removeEventListener('seeked', this.hideFullscreenButton); //@todo: paused + seeked
            el.removeEventListener('timeupdate', this.updateVideoTimeTracker);
        },


        updateVideoTimeTracker() {
            try {
                if (!(this.$refs.videoElement instanceof HTMLMediaElement)) {
                    return;
                }
                const t = this.$refs.videoElement.currentTime;
                let diff = t - this.prevVideoTime;
                this.prevVideoTime = t;
                if (diff <= 1 && diff > 0) this.totalVideoTime += diff;
            } catch(error) {
                captureException(error);
            }
        },

        showFullscreenButton() {
            this.fullScreenButtonVisible = true;
            window.clearTimeout(this.fullScreenButtonTimeout);
        },

        hideFullscreenButton(delay = 1000) {
            this.fullScreenButtonTimeout = setTimeout(()=>{
                this.fullScreenButtonVisible = false;
            }, delay);
        },

        /**
             * Load animation data with the requested ID
             *
             * @return {void}
             */
        getItem() {
            try {
                for (const i in this.$store.state.animation.animationItems) {
                    if (parseInt(this.$store.state.animation.animationItems[i].id) === parseInt(this.id)) {
                        return this.$store.state.animation.animationItems[i];
                    }
                }

                console.error(`Animation with id ${this.id} not found`);

                this.error = true;
            } catch(error) {
                captureException(error);

                this.error = true;
            }
        },

        async injectAsset(url, type = "script") {
            return new Promise(function(resolve, reject) {
                const fullUrl = "https://static.planmaster.hu/" + url;
                const el = document.createElement(type);
                el.onload = () => {
                    resolve();
                };
                el.onerror = (e) => {
                    reject(e);
                };
                if (type === "script") el.src = fullUrl;
                if (type === "link") {
                    el.rel = "stylesheet";
                    el.href = fullUrl;
                }
                document.head.appendChild(el); // or something of the likes
            });
        },
    },
};
</script>
